import { useMemo } from 'react'
import { useLiveQuery } from 'dexie-react-hooks'
import {
  getDb,
  readableOutbox,
  readSitePack,
  type OutboxRecord,
  type StoredSitePack,
} from '@/offline'
import { projectProcess, PROCESS_TYPES, type ProcessState } from './projection'

export { useDraftState, useNow } from '@/features/store/useStore'

const EMPTY: OutboxRecord[] = []

export interface UseProcessState {
  loading: boolean
  /** null when no site pack has been downloaded. */
  state: ProcessState | null
  stored: StoredSitePack | null
}

/** The projected site (pack + this phone's own F6/F7 commands and their sync results), live. */
export function useProcessState(): UseProcessState {
  const stored = useLiveQuery(async () => (await readSitePack()) ?? null, [], undefined)
  const outbox = useLiveQuery(
    async () => {
      const db = getDb()
      return readableOutbox(
        await db.outbox
          .where('type')
          .anyOf([...PROCESS_TYPES])
          .toArray(),
        db,
      )
    },
    [],
    EMPTY,
  )
  const state = useMemo(() => (stored ? projectProcess(stored, outbox) : null), [stored, outbox])
  return { loading: stored === undefined, state, stored: stored ?? null }
}
